// extracted by mini-css-extract-plugin
module.exports = {"shapeImage":"NumberAnswer_shapeImage__3khHq","imageContainer":"NumberAnswer_imageContainer__2beID"};